'use strict';
var $ = require('jquery');
require('jquery-validation');
var futureRules = require('./futureRules');

var formErrorsConfig = {
    errorElementIdPostfix : "-error",
    errorElement : "span",
    errorClass : "help-block",
    parentErrorClass: "has-error",
    groupParentSelector: ".form-group"
};

var defaultConfig = {
    invalidHandler: scrollToFirstError,
    onkeyup : function(element, event) {
        // Avoid revalidate the field when pressing one of the following keys
        // Shift       => 16
        // Ctrl        => 17
        // Alt         => 18
        // Caps lock   => 20
        // End         => 35
        // Home        => 36
        // Left arrow  => 37
        // Up arrow    => 38
        // Right arrow => 39
        // Down arrow  => 40
        // Insert      => 45
        // Num lock    => 144
        // AltGr key   => 225
        var excludedKeys = [
            16, 17, 18, 20, 35, 36, 37,
            38, 39, 40, 45, 144, 225
        ];

        if ( event.which === 9 || $.inArray( event.keyCode, excludedKeys ) !== -1 ) {
            return;
        }

        futureRules.evalMinLength(element);

        this.element(element);
        if (this.settings.onkeyupCallback) {
            this.settings.onkeyupCallback();
        }

    },
    onfocusout : function(element, event) {
        //ignore date picker element, and bootstrap-select
        if ($(element).parent().is('.input-group.date, .bootstrap-select')) {
            return;
        }
        futureRules.evalMinLength(element, true);
        this.element(element);
        if (this.settings.onfocusoutCallback) {
            this.settings.onfocusoutCallback();
        }
    },
    ignore : "input.combobox, select.combobox",
    groups: {},
    highlight : function(element) {
        $(element).closest(formErrorsConfig.groupParentSelector).addClass(formErrorsConfig.parentErrorClass);
    },
    unhighlight : function(element) {
        $(element).closest(formErrorsConfig.groupParentSelector).removeClass(formErrorsConfig.parentErrorClass);
    },
    errorElement : formErrorsConfig.errorElement,
    errorClass : formErrorsConfig.errorClass,
    errorPlacement : handleErrorPlacement,
    submitHandler : function(form) {
        form.submit();
    }
};

/**
 * Creates jquery validator for the provided form and config object
 * form - jquery selected form
 * configObject - to overwrite default config in this file. Accepts all options defined in https://jqueryvalidation.org/validate/
 *  in addition accepts the following:
 *      onkeyupCallback - function to be invoked at the end of onkeyup event
 *      onfocusoutCallback - function to be invoked at the end of onfocusout event
 */
function createValidator(form, configObject) {
    var configToApply = $.extend({}, defaultConfig, configObject);
    form.on("submit.validate", function(event) {
        futureRules.applyAllFutureRules(form);
    });

    var formValidator = form.validate(configToApply);

    form.on("change", '.selectpicker, .datepicker, input[type=radio], input[type=checkbox], .combobox-namedElement' , function(event) {
        formValidator.element(event.target);
        if (formValidator.settings.onkeyupCallback) {
            formValidator.settings.onkeyupCallback();
        }
    });

    return formValidator;
}

function handleErrorPlacement(error, element) {
    removeExistingError(element.attr('id'));
    //for radio buttons need to go 2 levels up to avoid the label
    if (element.attr('type') === 'radio') {
        error.appendTo(element.closest('.radio-button-group'));
        return;
    }

    if (element.parent(".input-group, .combobox-container").length) {
        error.insertAfter(element.parent());
    } else {
        error.appendTo(element.parent());
    }
}

/*
 * Removes an existing error from the specified element input. This is to ensure we only
 * ever show a single error message per field.
 */
function removeExistingError(elementId) {
    // e.g. select and existing "#staffNumber-error" error element, and remove it
    $('#' + elementId + formErrorsConfig.errorElementIdPostfix).remove();
}

/*
 * Scrolls the page to the first error following a failed form submission. This takes the height
 * of the nav bar into account also.
 */
function scrollToFirstError(event, validator) {
    if (!validator.numberOfInvalids()) {
        return;
    }

    var $formGroupParent = $(validator.errorList[0].element).parents('.form-group').first();

    if($formGroupParent.length) {
        var firstErrorOffset = $formGroupParent.offset().top;
        var navBarHeight = $('#nav-bar-top').height();

        var offset = firstErrorOffset - navBarHeight - 30;

        $('html, body').animate({
            scrollTop: offset
        }, 750);
    }
}

var validationMessages, validationRegexes = {
    "intl.mobile.code": "(\\\\+\\\\d{1,4})",
    "intl.mobile.number": "^[0-9]{7,13}$"
};


var loading;

/*
 * Loads the validation regexs and the validation messages for use with the
 * inline validation
 */
function loadValidationMessages() {
    loading = $.ajax({
        type : "GET",
        url : "/online-services/validations",
        dataType : 'json',
        contentType : 'application/json; charset=utf-8'
    }).done(function(data) {
        validationMessages = $.extend(validationMessages, data.validationMessages);
        validationRegexes = $.extend(validationRegexes, data.validationRegexes);
        console.log('online-services error messages loaded');
    }).fail(function(e) {
        console.log('Failed to load validation messages', e);
    });
    return loading;
}

/*
 * Function to retrieve an error value based on the specified keys. It
 * returns the key used, if no value is found.
 *
 * @param fallbackMessageKey The fallback message key to use, for when the
 * errorMessage key is undefined. This is a required parameter.
 * @param errorMessageKey The error message key to use. This is an optional
 * parameter.
 */
function getErrorMessage(fallbackMessageKey, errorMessageKey) {
    if (typeof validationMessages !== 'undefined') {
        console.log("Error key = %s, default key = %s", errorMessageKey, fallbackMessageKey);
        var theKey = errorMessageKey ? errorMessageKey : fallbackMessageKey;
        return validationMessages[theKey] ? validationMessages[theKey] : theKey;
    } else {
        return fallbackMessageKey;
    }
}

/*
 * Method to provide customized error messages from alfresco.
 * bridges the gap of jquery-validator sync messages call to async retrieval of alfresco content
*/
function errorByKey(key) {
    return function(rule, element) {
        if (loading.state() === 'pending') {
                console.error('Unable to fetch validation error messages in time before validation');
        }
        return getErrorMessage(key);
    };
}

/**
 * Binds a new function which is able to render server side validation messages
 * @param formSelector - selector for form where error messages must be displayed
 * @returns {Function} handles server output
 */
function renderServerErrors(formSelector) {
    return function(jqXHR, message, result) {

            if (jqXHR.status === 422 && jqXHR.responseJSON) {
                result = jqXHR.responseJSON;
                var errorArray = result.fieldErrors.reduce(function(errorArray, fieldError){
                    var name = fieldError.field;
                    var validator = $(formSelector).validate();
                    var element = validator.currentElements.filter("[name='"+name+"']").get(0);
                    if (element) {
                        var message = validator.defaultMessage(element, {method: fieldError.code});
                        errorArray[name] = message;
                    } else {
                        console.log("Unable to find field "+ name +" in form with selector " + formSelector);
                    }

                    return errorArray;
                }, {});


                $(formSelector).validate().showErrors(errorArray);
            }
        };
}

/**
 * validates form
 * to be used instead of $().valid() method when futureRules are at play
 * @param formSelector
 * @returns boolean true if form is valid
 */
function validate(formSelector) {
    futureRules.applyAllFutureRules(formSelector);
    return $(formSelector).valid();
}

/**
 * checks if form is valid, without rendering error messages
 * @param formSelector
 * @returns boolean - true if form is valid and no futureRules remain
 */
function isValid(formSelector) {
    return $(formSelector).validate().checkForm();
}

//fetch error messages on load
loadValidationMessages();

module.exports.createValidator = createValidator;
module.exports.renderServerErrors = renderServerErrors;
module.exports.validate = validate;
module.exports.isValid = isValid;

module.exports.errorByKey = errorByKey;
module.exports.getErrorMessage = getErrorMessage;
module.exports.validationRegexes = validationRegexes;

//for convenience expose frequently used methodsd of futureRules
module.exports.renderingDone = futureRules.renderingDone;
module.exports.hasNoFutureRules = futureRules.hasNoFutureRules;
module.exports.elemHasNoFutureRule = futureRules.elemHasNoFutureRule;

//for testing only
module.exports.loading = loading;
module.exports.loadValidationMessages = loadValidationMessages;






//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/forms/validation.js
// module id = kMMZ
// module chunks = 1 2 5